function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
export { _nonIterableRest as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/nonIterableRest.js
// module id = 1075
// module chunks = 0